import React, { useState } from "react";
import "../styles/StaffHiring.css";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { submitStaffHiringForm } from "../services/gurukulService";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const StaffHiring = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    subject: "",
    name: "",
    fatherName: "",
    dob: "",
    village: "",
    tehsil: "",
    district: "",
    pinCode: "",
    secondaryYear: "",
    secondaryMarks: "",
    graduationYear: "",
    graduationMarks: "",
    bedYear: "",
    bedMarks: "",
    universityName: "",
    diplomaYear: "",
    diplomaMarks: "",
    otherQualifications: "",
    contact: "",
    email: "",
    agreement: false,
  });
  const pdfUrl = "/Requirement_26_27.pdf";

  const handleChange = (e) => {
    if (e instanceof Date) {
      // Handle DatePicker input
      setFormData((prevData) => ({
        ...prevData,
        dob: e.toISOString().split("T")[0], // Store date in 'YYYY-MM-DD' format
      }));
    } else {
      const { name, value, type, checked } = e.target;
      setFormData((prevData) => ({
        ...prevData,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };
  

const nextStep = () => setStep((prev) => prev + 1);
const prevStep = () => setStep((prev) => prev - 1);

// const DOBPicker = () => {
//   const [dob, setDob] = useState(dayjs("2000-01-01")) };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await submitStaffHiringForm(formData);
      alert("आवेदन सफलतापूर्वक जमा हो गया! / Application submitted successfully! ( Pay Application Fee) ");
      
      // Reset form data after successful submission
      setFormData({
        subject: "",
        name: "",
        fatherName: "",
        dob: "",
        village: "",
        tehsil: "",
        district: "",
        pinCode: "",
        secondaryYear: "",
        secondaryMarks: "",
        graduationYear: "",
        graduationMarks: "",
        bedYear: "",
        bedMarks: "",
        universityName: "",
        diplomaYear: "",
        diplomaMarks: "",
        otherQualifications: "",
        contact: "",
        email: "",
        agreement: false,
      });
  
      setStep(1);
    } catch (error) {
      alert("⚠️ फॉर्म जमा करने में त्रुटि हुई। कृपया सभी आवश्यक फ़ील्ड भरें। / Error in form submission. Please fill all required fields.");
    }
  };

  

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <div className="form-section">
            <h3>Step 1: Personal Information | व्यक्तिगत जानकारी</h3>
            <div className="form-group">
              <label>विषय जिसके लिए आवेदन कर रहे हैं | Subject for Application:<span className="required">*</span></label>
              <select name="subject" value={formData.subject} onChange={handleChange} required>
                <option value="" disabled >कृपया चयन करें | Please Select</option>
                <option value="संस्कृत">संस्कृत | Sanskrit</option>
                <option value="संस्कृत संभाषण">संस्कृत संभाषण | Sanskrit Conversation</option>
                <option value="अंग्रेजी">अंग्रेजी | English</option>
                <option value="Spoken English">Spoken English</option>
                <option value="विज्ञान">विज्ञान | Science</option>
                <option value="हिंदी">हिंदी | Hindi</option>
                <option value="गणित">गणित | Mathematics</option>
                <option value="सामाजिक विज्ञान">सामाजिक विज्ञान | Social Science</option>
                <option value="संगीत शिक्षक">संगीत शिक्षक | Music Teacher</option>
                <option value="शारीरिक शिक्षक">शारीरिक शिक्षक | Physical Education Teacher</option>
                <option value="योग शिक्षक">योग शिक्षक | Yoga Teacher</option>
                <option value="कम्प्यूटर शिक्षक">कम्प्यूटर शिक्षक | Computer Teacher</option>
                <option value="छात्रावास प्रभारी">छात्रावास प्रभारी | Hostel Warden</option>
                <option value="लेखापाल">लेखापाल | Accountant</option>
                <option value="चतुर्थ श्रेणी कर्मचारी">चतुर्थ श्रेणी कर्मचारी | Class IV Employee</option>
                <option value="सुरक्षा कर्मी">सुरक्षा कर्मी | Security Guard</option>
                <option value="नर्सिंग ऑफिसर">नर्सिंग ऑफिसर | Nursing Officer</option>
              </select>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>अभ्यर्थी का नाम | Name:<span className="required">*</span></label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="form-row">
            <div className="form-group">
                <label>पिता का नाम | Father's Name:<span className="required">*</span></label>
                <input
                  type="text"
                  name="fatherName"
                  value={formData.fatherName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                  <label>जन्म तिथि | Date of Birth:</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Date of Birth"
                      value={formData.dob ? dayjs(formData.dob) : null} // Ensure compatibility with dayjs
                      onChange={(newValue) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          dob: newValue ? dayjs(newValue).format("YYYY-MM-DD") : "", // Store in correct format
                        }));
                      }}
                      views={["year", "month", "day"]}
                      disableFuture
                    />
                  </LocalizationProvider>
                </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>गांव  | Village:<span className="required">*</span></label>
                <input
                  type="text"
                  name="village"
                  value={formData.village}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>तहसील | Tehsil:<span className="required">*</span></label>
                <input
                  type="text"
                  name="tehsil"
                  value={formData.tehsil}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>जिला | District:<span className="required">*</span></label>
                <input
                  type="text"
                  name="district"
                  value={formData.district}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>पिन कोड | Pin Code:</label>
                <input
                  type="text"
                  name="pinCode"
                  value={formData.pinCode}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="button-group">
              <button className="next-button" type="button" onClick={nextStep}>
                Next
              </button>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="form-section">
            <h3>Step 2: Academic Information | शैक्षणिक जानकारी</h3>
            <div className="form-row">
              <div className="form-group">
                <label>माध्यमिक कक्षा उत्तीर्ण वर्ष | Secondary Year:<span className="required">*</span></label>
                <input
                  type="text"
                  name="secondaryYear"
                  value={formData.secondaryYear}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>माध्यमिक कक्षा के नामांक | Secondary Roll Number:<span className="required">*</span></label>
                <input
                  type="text"
                  name="secondaryMarks"
                  value={formData.secondaryMarks}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>स्नातक उत्तीर्ण वर्ष | Graduation Year:</label>
                <input
                  type="text"
                  name="graduationYear"
                  value={formData.graduationYear}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>स्नातक अंतिम वर्ष के नामांक | Graduation Roll Number:</label>
                <input
                  type="text"
                  name="graduationMarks"
                  value={formData.graduationMarks}
                  onChange={handleChange}
                  required
                />
              </div>
              
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>शिक्षा स्नातक उत्तीर्ण वर्ष | B.Ed. Year:</label>
                <input
                  type="text"
                  name="bedYear"
                  value={formData.bedYear}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>शिक्षा स्नातक नामांक | B.Ed. Roll Number:</label>
                <input
                  type="text"
                  name="bedMarks"
                  value={formData.bedMarks}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>शिक्षा स्नातक विश्वविद्यालय का नाम | University Name:</label>
                <input
                  type="text"
                  name="universityName"
                  value={formData.universityName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label> प्रारंभिक शिक्षा में डिप्लोमा उत्तीर्ण वर्ष | Diploma Year:</label>
                <input
                  type="text"
                  name="diplomaYear"
                  value={formData.diplomaYear}
                  onChange={handleChange}
                  required
                />
              </div>
              </div>

              <div className="form-row">
              <div className="form-group">
                <label>प्रारंभिक शिक्षा में डिप्लोमा अंतिम वर्ष के नामांक | Diploma Marks::</label>
                <input
                  type="text"
                  name="diplomaMarks"
                  value={formData.diplomaMarks}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>अन्य योग्यता | Other Qualifications :</label>
                <input
                  type="text"
                  name="otherQualifications"
                  value={formData.otherQualifications}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="button-group">
              <button className="prev-button" type="button" onClick={prevStep}>
                Back
              </button>
              <button className="next-button" type="button" onClick={nextStep}>
                Next
              </button>
            </div>
            
          </div>
        );
      case 3:
        return (
          <div className="form-section">
            <h3>Step 3: Contact Information | संपर्क जानकारी</h3>
            <div className="form-row">
              <div className="form-group">
                <label>संपर्क सूत्र | Contact Number:<span className="required">*</span></label>
                <input
                  type="text"
                  name="contact"
                  value={formData.contact}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label> ई-मेल पता | Emai:<span className="required">*</span></label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="form-group agreement">
            <label>
                <input
                type="checkbox"
                name="agreement"
                checked={formData.agreement}
                onChange={handleChange}
                required
                style={{ width: "20px", height: "20px", marginRight: "10px" }} // Inline styling
                />
                चयनोपरांत संस्थान किसी भी गुरुकुल में सेवा हेतु भेज सकता है। क्या आप इसके लिए सहमत हैं? | Do you agree to be sent to any Gurukul?
            </label>
            </div>
            <div className="button-group">
              <button className="prev-button" type="button" onClick={prevStep}>
                Back
              </button>
              <button className="submit-button" type="submit">
                Submit
              </button>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  // return (
  //   <div className="form-container">

  //     {/* Download Button */}
  //     <div className="pdf-download">
  //       <a href={pdfUrl} download className="download-btn">
  //         Download Application Guide (PDF)
  //       </a>
  //     </div>
  //     <h2>अभ्यर्थी आवेदन - पत्र (2025-2026) | STAFF APPLICATION FORM </h2>
  //     <p> Application Fee - 100 Rs</p>
  //     <form onSubmit={handleSubmit}>{renderStep()}</form>
      
  //   </div>
    
  // );
return (
  <div className="form-container" style={{ textAlign: "center" }}>
    <h1>श्री खेतेश्वर गुरुकुल</h1>
    <h2>स्टाफ भर्ती सूचना | Staff Recruitment Notification</h2>

    {/* Download Button */}
    <div className="pdf-download">
      <a href={pdfUrl} download className="download-btn">
        Download Recruitment Notification & Application Guide (PDF)
      </a>
    </div>

    <p style={{ fontSize: "18px", marginTop: "20px" }}>
      यह पृष्ठ <strong>स्टाफ भर्ती की आधिकारिक सूचना</strong> है।
      <br />
      This page contains the <strong>official staff recruitment notification</strong>.
    </p>

    <p style={{ fontSize: "17px", marginTop: "15px" }}>
      सभी योग्य उम्मीदवारों से अनुरोध है कि आवेदन करने से पहले
      <strong> भर्ती सूचना (PDF) </strong> ध्यानपूर्वक पढ़ें।
      <br />
      Candidates are advised to carefully read the recruitment notification (PDF)
      before applying.
    </p>

    <p style={{ fontSize: "17px", marginTop: "15px" }}>
      स्टाफ भर्ती के लिए आवेदन केवल
      <strong> Google Form </strong> के माध्यम से स्वीकार किए जाएंगे।
      <br />
      Applications for staff recruitment will be accepted <strong>only through the Google Form</strong>.
    </p>

    {/* Application Link */}
    <a
      href="https://docs.google.com/forms/d/e/1FAIpQLScINTbTAk4ckawGUstUb6w3FkHohVqMU6kRgoxRdu1L6qukHw/viewform?usp=header"
      target="_blank"
      rel="noopener noreferrer"
      className="submit-button"
      style={{ display: "inline-block", marginTop: "30px" }}
    >
      Apply Now | आवेदन करें (2026–2027)
    </a>
  </div>
);


};

export default StaffHiring;
    